<template>
  <div id="mageageIcon" @click="mangeTab">
    <!-- <i class="iconfont pointer" style="font-size: 22px">&#xe6a0;</i> -->
    <span>系统管理</span>
  </div>
</template>

<script lang="ts" setup>
const emits = defineEmits(["tab"]);
const mangeTab = () => {
  emits("tab", 2);
};
</script>
<style lang="less" scoped>
#mageageIcon {
  cursor: pointer;
  // margin-right: 30px;
  // display: flex;
  // span {
  // margin-left: 8px;
  // }
}
</style>
